import styled from '@emotion/styled';
import Backdrop from '@material-ui/core/Backdrop';

// TODO: this is temporarily disabled due to a Chrome bug
const BackdropWithDesaturation = styled(Backdrop)({
  // backdropFilter: 'saturate(50%)'
});

export default BackdropWithDesaturation;
